import { FunctionComponent, useState } from 'react'
import { SignUpLinkedIn, SignUpEmail } from './components/sign-up'
import { Box, Divider, Link, Typography } from '@material-ui/core'
//@ts-ignore
import { useTheme } from 'styled-components'
import { BackendUser, UserRoles } from 'common/types'
import { SignUpMessage } from './components/sign-up/SignUpMessage'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import styled from 'styled-components/macro'

const StyledDivider = styled(Divider)`
  && {
    background-color: ${props => props.theme.colors.accent};
   
  }
`
interface SignUpProps {
  onSubmit: Function
  mode: UserRoles
  username: string
  password: string
  setUsername: Function
  setPassword: Function
  onLogin: Function
  title?: string
  user: BackendUser
  confirmEmail?: Function
  errorCount?: number
  setErrorCount?: Function
  setShowTicketModal?: Function
  success?: boolean
  setSuccess?: Function
  setForwardingUrl?: Function
  timer: number
  setTimer: Function
  errorFlag: boolean
  setErrorFlag: Function
  errorMessage: string
  setErrorMessage: Function
  getItem: Function
  clearItem: Function
  showConfirmEmailModal: boolean
  setShowConfirmEmailModal: Function
  resendConfirmationCode: Function
  isLocked: boolean
  setIsLocked: Function
  handleUsernameChange: Function
}

const SignUp: FunctionComponent<SignUpProps> = ({
  mode,
  onLogin,
  username,
  password,
  setUsername,
  setPassword,
  onSubmit,
  user,
  confirmEmail,
  errorCount,
  setErrorCount,
  timer,
  setTimer,
  errorFlag,
  setErrorFlag,
  errorMessage,
  setErrorMessage,
  getItem,
  clearItem,
  showConfirmEmailModal,
  setShowConfirmEmailModal,
  isLocked,
  setIsLocked,
  handleUsernameChange,
  resendConfirmationCode
}) => {
  const theme = useTheme()
  const [showEmailSignUp, setShowEmailSignUp] = useState(false)
  const { isDevice } = useScreenSizes()
  const toggleEmailSignUp = () => {
    setShowEmailSignUp(!showEmailSignUp)
  }

  return (
    <Box display="flex" flexDirection="column" justifyItems="left" alignItems="center">
      <SignUpMessage role={mode} onLogin={onLogin} />
      <SignUpLinkedIn showEmailSignUp={toggleEmailSignUp} role={mode} onLogin={onLogin} />
      <Box maxWidth="100%" display="flex" justifyContent="center">
        <StyledDivider style={{ width: isDevice ? '350%' : '495%' }} />
        <Typography variant="caption">
          <Box color={theme.colors.accent} position="relative" top="-0.8em" padding="0 1em">
            OR
          </Box>
        </Typography>
        <StyledDivider style={{ width: isDevice ? '390%' : '490%' }} />
      </Box>

      <SignUpEmail
        username={username}
        password={password}
        setUsername={setUsername}
        setPassword={setPassword}
        onSubmit={onSubmit}
        role={mode}
        user={user}
        confirmEmail={confirmEmail}
        errorCount={errorCount}
        setErrorCount={setErrorCount}
        timer={timer}
        setTimer={setTimer}
        errorFlag={errorFlag}
        setErrorFlag={setErrorFlag}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        getItem={getItem}
        clearItem={clearItem}
        showConfirmEmailModal={showConfirmEmailModal}
        setShowConfirmEmailModal={setShowConfirmEmailModal}
        resendConfirmationCode={resendConfirmationCode}
        isLocked={isLocked}
        setIsLocked={setIsLocked}
        handleUsernameChange={handleUsernameChange}
      />
      <Box padding="10px">
        <Typography variant="body2" align="center">
          <Box color={theme.colors.accent1}>
            By clicking <strong>Sign Up</strong>, you agree to our{' '}
            <Link
              href="https://obsidi.com/terms-of-use/"
              target="_blank"
              style={{
                display: 'inline-block'
              }}
            >
              Terms and Conditions
            </Link>  and
            <Link
              href="https://obsidi.com/privacy-policy/"
              target="_blank"
              style={{
                display: 'inline-block',
                marginLeft: '0.4em'
              }}
            >
              Privacy Statement
            </Link>
          </Box>
        </Typography>
      </Box>
    </Box>
  )
}

export default SignUp
